// import { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Goals from "./components/Goals/Goals";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:locationId" element={<Goals/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

